import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ApiService } from '@meddatacore/common';
import { HttpParamsEncoder } from '../../tools';
import { DataSourceResponse, WorkPlace } from '../../models';
@Injectable({ providedIn: 'root' })
export class WorkPlaceService extends ApiService {
    endPoint = '/api/WorkPlaces';
    create(model: WorkPlace) {
        return this.http.post(`${this.queueUrl}${this.endPoint}`, model);
    }
    edit(id: string, model: WorkPlace) {
        return this.http.put(`${this.queueUrl}${this.endPoint}/${id}`, model);
    }
    get(id: string): Observable<WorkPlace> {
        return this.http.get<WorkPlace>(`${this.queueUrl}${this.endPoint}/${id}`);
    }
    delete(id: string) {
        return this.http.delete<any>(`${this.queueUrl}${this.endPoint}/${id}`);
    }
    getList(queryParams: any): Observable<DataSourceResponse<WorkPlace>> {
        const params = new HttpParamsEncoder().encode(queryParams);
        return this.http.get<any>(`${this.queueUrl}${this.endPoint}`, { params });
    }
}
